module.exports = __webpack_public_path__ + "static/media/game-path.ee5602e9.webp";